import { Permission } from '@bookora/shared';
import type { RouteObject } from 'react-router-dom';

import { RequirePermission } from '@/app/require-permission';
import { RouteErrorBoundary } from '@/components/route-error-boundary';

import StaffSchedulePage from './staff-schedule-page';

/**
 * Child routes contributed by the staff feature.
 *
 * ── `/staff/:staffId/working-hours` IS A CONTRACT ───────────────────────────
 *
 * The calendar reads working hours to draw its day grid and links here when a
 * shift needs changing, and the settings section's roster links here too. That
 * makes the path a published surface between three features: renaming it breaks
 * links already shipped, so if it ever has to move, leave a redirect behind.
 *
 * The gate is `appointment.view` OR `staff.view` — the keys the page's own
 * reads require (`GET /staff/:id/working-hours` and `GET /time-off` are
 * `RequireAnyPermission(APPOINTMENT_VIEW, STAFF_VIEW)`). It used to admit
 * `settings.view` alone, whose every query on this page 403s. The editor
 * itself falls back to read-only without `settings.edit`.
 */
export const routes: RouteObject[] = [
  {
    path: 'staff/:staffId/working-hours',
    element: (
      <RequirePermission anyOf={[Permission.APPOINTMENT_VIEW, Permission.STAFF_VIEW]}>
        <StaffSchedulePage />
      </RequirePermission>
    ),
    // On the LEAF, per `app/router.tsx`'s contract. Without it a render throw
    // here bubbles past `AppLayout` to the `Root` boundary and replaces the
    // whole application — sidebar, clinic switcher, notification bell — which
    // is precisely the outcome that contract exists to prevent.
    errorElement: <RouteErrorBoundary />,
  },
];
